import {formatPhoneNumberIntl} from 'react-phone-number-input'

export const formatPhone = (phone: string): string => {
  return formatPhoneNumberIntl(phone.includes('+') ? phone : `+${phone}`)
}
